import { PageControl } from "@/interface/FullscreenPresentationLayout/PresentationNavigation/PageControl";
import { ReloadControl } from "@/interface/FullscreenPresentationLayout/PresentationNavigation/ReloadControl";
import { ZoomControl } from "@/interface/FullscreenPresentationLayout/PresentationNavigation/ZoomControl";
import styles from "../FullscreenPresentationLayout.module.scss";
import type { TurnDirection, ZoomDirection } from "../types";

type PresentationNavigationProps = {
    currentSlide: number;
    totalSlides: number;
    zoom: number;

    onTurnSlide: (direction: TurnDirection) => void;
    onChangeZoom: (direction: ZoomDirection) => void;
    onReload: () => void;
};

export const PresentationNavigation = ({
    currentSlide,
    totalSlides,
    zoom,
    onTurnSlide,
    onChangeZoom,
    onReload,
}: PresentationNavigationProps) => {
    return (
        <div className={styles.navigation}>
            <PageControl
                currentSlide={currentSlide}
                totalSlides={totalSlides}
                onTurnSlide={onTurnSlide}
            />
            <ZoomControl zoom={zoom} onChangeZoom={onChangeZoom} />
            <ReloadControl onReload={onReload} />
        </div>
    );
};
